/**
 * File types
 * DEFAULT .xls.xlsx.csv.txt.pdf.zip
 * Funding and Loan by Loan .xsl.xlsx.csv
 * Summary .xsl .xslx
 */
const MSEXCEL_FILE_TYPES = '.xls,.xlsx';
const CNC_MSEXCEL_FILE_TYPES = '.xls,.xlsx,.xlsb,.xlsm';
const MSDOC_FILE_TYPES = '.doc,.docx,.docm';
const CSV_FILE_TYPE = '.csv';
const TEXT_FILE_TYPE = '.txt';
const PDF_FILE_TYPE = '.pdf';
const ZIP_FILE_TYPE = '.zip';
const MSPP_FILE_TYPE = '.pptx,.pptm';
export const DEFAULT_REQUEST_FILE_TYPES = `${MSEXCEL_FILE_TYPES},${CSV_FILE_TYPE},${TEXT_FILE_TYPE},${PDF_FILE_TYPE},${ZIP_FILE_TYPE}`;
export const FUNDING_REQUEST_FILE_TYPES = `${MSEXCEL_FILE_TYPES},${CSV_FILE_TYPE}`;
export const FUNDING_SUMMARY_REQUEST_FILE_TYPES = MSEXCEL_FILE_TYPES;

export const CNC_DEFAULT_REQUEST_FILE_TYPES = `${CNC_MSEXCEL_FILE_TYPES},${MSDOC_FILE_TYPES},${CSV_FILE_TYPE},${TEXT_FILE_TYPE},${PDF_FILE_TYPE},${ZIP_FILE_TYPE}`;
export const CNC_FUNDING_REQUEST_FILE_TYPES = CNC_DEFAULT_REQUEST_FILE_TYPES;
export const CNC_PAYDOWN_NOTICE_FILE_TYPES = CNC_DEFAULT_REQUEST_FILE_TYPES;
export const CNC_SERVICER_REPORT_FILE_TYPES = CNC_DEFAULT_REQUEST_FILE_TYPES;
export const CNC_OTHER_DOCUMENT_FILE_TYPES = CNC_DEFAULT_REQUEST_FILE_TYPES;
export const CNC_FINANCIAL_STATEMENTS_FILE_TYPES = CNC_DEFAULT_REQUEST_FILE_TYPES;
export const getIcSubmissionFileTypes = (name: string) => {
  switch (name) {
    case 'Presentation':
      return `${MSPP_FILE_TYPE},${PDF_FILE_TYPE}`;
    case 'Asset Yield Calculator':
    case 'ESG Memo':
      return `${MSEXCEL_FILE_TYPES}`;
    case 'Rep Risk Questionnaire':
      return `${MSDOC_FILE_TYPES}`;
    default:
      return `${MSPP_FILE_TYPE},${PDF_FILE_TYPE}`;
  }
};
